export default __webpack_public_path__ + "static/media/grandmaster.c5dad35a.png";